import { useQuery } from "@tanstack/react-query";
import { listCountries } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";
import { STATIC_COUNTRIES } from "@/components/CountrySelect";

export function useCountries({ enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.countries,
    queryFn: listCountries,
    staleTime: staleTimes.countries,
    enabled,
    initialData: { countries: STATIC_COUNTRIES },
  });
}
